import { render, staticRenderFns } from "./StandardValue.vue?vue&type=template&id=0c269e9a&"
import script from "./StandardValue.vue?vue&type=script&lang=js&"
export * from "./StandardValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports